import React, { createElement, useEffect, useState } from 'react';
import { Input, Form, Col } from 'antd';
import { generateRules } from '../../../utils';
import './index.scss';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
const { TextArea } = Input;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const FormTextArea = (props, ref) => {
    const { isNecessary, verifytext, title, __id, rules, areaHeight, autoSize, status, span, column, ...other } = props;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [rule, setRule] = useState([]);
    useEffect(() => {
        setError(false);
        try {
            setRule(generateRules(rules));
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('校验规则初始化出错,检查配置或更新组件');
        }
    }, [rules]);
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement(Col, { span: column || span },
        createElement("div", { ref: ref, className: "base_bg" },
            createElement(Form.Item, { label: title || '多行文本', name: __id || props.componentId, rules: rule },
                createElement(TextArea, Object.assign({ disabled: status === 'readonly' || urlParams.get('edit') === '3' }, other, { autoSize: autoSize ? true : { minRows: areaHeight } }))))))));
};
export default React.forwardRef(FormTextArea);
